export class TraineeRotationsModel {
	Id: string;
	FacultyRotationId: string;
	StudentId: string;
	StudentFullName: string;
	HospitalId: string;
	ScheduleHospitalId: string;
	ScheduledHospitalName: string;
	HospitalName: string;
	Unit: string;
	StartedOn: string;
	CompletedOn: string;
	SupervisorId: string;
	SupervisorFullName: string;
	Faculty: string;
	ApprovalStatus: string;
	IsActive: boolean;
	Remark: string;
	CreatedOn: string;
	StudentRotationScheduleId: string;
	RotationTypeId: number;
	RefNo: string;
}
